import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=e0b8fbd6&"
import script from "./MainDrawer.vue?vue&type=script&lang=ts&"
export * from "./MainDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports